import React from 'react'
import { User } from '@graphics/gfx-common/dist/types'
import * as date from '../../services/date'
import { Space } from '../../layouts'
import { H3, P } from '../StyledText'

interface IEditedItem {
  modified: string
  modifiedBy: User
}

export const EditedItem = ({ modified, modifiedBy }: IEditedItem) => (
  <>
    <Space mb={4}>
      <H3 mb={2}>Last modified</H3>
      <P>{date.calendar(modified)}</P>
    </Space>
    <Space mb={4}>
      <H3 mb={2}>Edited by</H3>
      <P>{modifiedBy.name}</P>
    </Space>
  </>
)
